import React from "react";
import SelectOrderStrategy from "./SelectOrderStrategy";
import {OrderItemQuantityLimitStrategies} from "../../../../app/order/GetStrategies";

const SelectOrderItemQuantityLimitStrategy = React.forwardRef(({onChange, ...props}, ref) => (
    <SelectOrderStrategy onChange={onChange} strategies={OrderItemQuantityLimitStrategies} {...props} ref={ref}/>
));

export default SelectOrderItemQuantityLimitStrategy;